import React from "react";
import "./Solution.css";
import video from "./video.mp4";
import appstore from "./appstore.png";
import Aos from "aos";
import "aos/dist/aos.css";
import { useEffect } from "react";

const Solution = () => {
  useEffect(() => {
    Aos.init();
  }, []);

  return (
    <>
      <div id="video-section-container">
        <div id="video-text">
          <h1 data-aos="fade-up" id="app-title">Our App</h1>
          <p data-aos="fade-up">
            Check out our app to gain the full stablty experience with
            personalized content, catered just for you.
          </p>
          <a href="https://apps.apple.com/us/app/stablty-llc/id1530005012">
            <img data-aos="fade-up" id="app-store" src={appstore} />
          </a>
        </div>

        <div id="video-container">
          <video data-aos="fade-up" id="video" controls width="340px" height="340px">
            <source src={video} type="video/mp4"></source>
          </video>
        </div>
      </div>
    </>
  );
};

export default Solution;
